import { render, staticRenderFns } from "./ReadLiberacao.vue?vue&type=template&id=75edcbbc&scoped=true"
import script from "./ReadLiberacao.vue?vue&type=script&lang=js"
export * from "./ReadLiberacao.vue?vue&type=script&lang=js"
import style0 from "./ReadLiberacao.vue?vue&type=style&index=0&id=75edcbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75edcbbc",
  null
  
)

export default component.exports